
    const projects = [

        {
            "id": 7,
            "image" : "https://user-images.githubusercontent.com/112969807/229422160-0533cd57-b994-41ac-b957-d6afd565c465.png",
            "title": "Shopzen",
            "bodyText": "Daily Objects is a E-commerce website which provides users to buy different types of products",
            "features": "Product Page | User authentication | User Management | filter | Admin Panel | Responsive",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
                {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/Codex-Swapnil1/Shopzen",
                    "textl": "Live",
                    "hrefl": "shopez-seven.vercel.app/"
                }
            ,
            "tags" : [
                "JavaScript",
                "HTML",
                "Netlify",
                "Node js",
                "MongoDB",
                "Express.js",
                "cyclic",
                "swiper",
                "React",
                "Redux",
                "Redux Thunks",
                "Chakra UI",
                "Styled Components"
            ]
        },
        {
            "id": 5,
            "image" : "https://user-images.githubusercontent.com/17249211/193621412-c3f4c5cd-457e-431c-80e2-23723643f6e2.png",
            "title": "Zara.com Clone",
            "bodyText": "ZARA.com which is well known for specializes in fast fashion online fashion store",
            "features": "Product Page | User authentication | Responsive",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
                {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/Codex-Swapnil1/Zara_Clone",
                    "textl": "Live",
                    "hrefl": "https://zara-origins.netlify.app/"
                }
            ,
            "tags" : [
                "JavaScript",
                "HTML",
                "Netlify",
                "CSS",
                "React",
                "Redux",
                "Redux Thunks",
                "Material UI",
                "Styled Components"

            ]
        },
        {
            "id": 6,
            "image" : "https://camo.githubusercontent.com/1e89bb5c36cc2d2d9489fe6811d0586842250195496a6bd9d4bcbd220c8c7a8b/68747470733a2f2f692e696d6775722e636f6d2f655a456a48704d2e706e67",
            "title": "Bath and Body Works Clone",
            "bodyText": "Bath & Body Works, LLC. is an American retail store chain that sells soaps, lotions, fragrances, and candles",
            "features": "Product Page | User authentication | Responsive",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
                {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/Codex-Swapnil1/Bath-Body-Works-E-commerce-Website-Clone",
                    "textl": "Live",
                    "hrefl": "https://bathbodyworksbymasai.netlify.app/"
                }
            ,
            "tags" : [
                "JavaScript",
                "HTML",
                "Netlify",
                "CSS",
                "React",
                "Redux",
                "Redux Thunks",
                "Chakra UI",
                "Styled Components"

            ]
        }
        ,
        {
            "id": 4,
            "image" : "projects/espncrickinfo.png",
            "title": "ESPN cricinfo Clone",
            "bodyText": "ESPN cricinfo is a sports news website exclusively for the game of cricket.",
            "features": "Home page | Responsive | Live Score",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
                {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/vedantpawar18/cricinfo.com",
                    "textl": "Live",
                    "hrefl": "https://cricinfo-clone.netlify.app"
                }
            ,
            "tags" : [
                "JavaScript",
                "HTML",
                "Netlify",
                "CSS",
                "E-commerce",
                "React",
                "Redux",
                "Redux Thunks",
                "Json-Server",
                "Chakra UI",
                "Styled Components"

            ]
        },
        {
            "id": 1,
            "image" : "projects/flipkart_project.png",
            "title": "Flipkart Clone",
            "bodyText": "Flipkart is one of India's leading E-commerce marketplaces",
            "features": "Social Sign-in/Sign-up | Product Page | User authentication",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
            {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/hemant-suryawanshi/Flipkart-Clone-1.0",
                    "textl": "Live",
                    "hrefl": "https://flipkart-clone-frontend.vercel.app/"
            }
            ,
            "tags" : [
                "JavaScript",
                "React",
                "HTML",
                "CSS",
                "E-commerce",
                "netlify"
            ]
        },
        {
            "id": 2,
            "image" : "projects/bigbasket.png",
            "title": "BigBasket Clone",
            "bodyText": "BigBasket is an online food and grocery store that delivers personal and household needs right to customers' doorstep.",
            "features": "Product Page | User authentication | Payment Gateway",
            "team": "A collaborative project built by a team of 5 executed in 5 days.",
            "links":
                {
                    "textg": "GitHub",
                    "hrefg": "https://github.com/S-hub1996/Big-basket-clone",
                    "textl": "Live",
                    "hrefl": "https://big-basket-clone-by-masai-school.netlify.app/"
                }
            ,
            "tags" : [
                "JavaScript",
                "Material UI",
                "React Redux",
                "React DOM",
                "Netlify",
                "CSS",
                "E-commerce"
            ]
        }
    ]

    export {projects}

        // {
        //     "id": 3,
        //     "image" : "projects/angel-place.png",
        //     "title": "Angle Place",
        //     "bodyText": "This project is a clone of firstcry.com which is well known online kids shopping store.",
        //     "features": "Product Page | User authentication | User Management",
        //     "team": "A collaborative project built by a team of 4 executed in 5 days.",
        //     "links":
        //         {
        //             "textg": "GitHub",
        //             "hrefg": "https://github.com/Codex-Swapnil1/Angel-Place",
        //             "textl": "Live",
        //             "hrefl": "https://sunny-meerkat-5e4a30.netlify.app/"
        //         }
        //     ,
        //     "tags" : [
        //         "JavaScript",
        //         "HTML",
        //         "Netlify",
        //         "MongoDB",
        //         "Express.js",
        //         "cyclic",
        //         "Node js",
        //         "swiper",
        //         "React",
        //         "Redux",
        //         "Redux Thunks",
        //         "Chakra UI",
        //         "Styled Components"
        //     ]
        // }
